"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJCycle = exports.CGJCycleElement = void 0;
class CGJCycleElement {
    constructor(name, time, color, sound = null, startCallback = null, endCallback = null, progressCallback = null, subCycles = []) {
        this.name = name;
        this.time = time;
        this.color = color;
        this.sound = sound;
        this.startCallback = startCallback;
        this.endCallback = endCallback;
        this.progressCallback = progressCallback;
        this.subCycles = subCycles;
        this.active = false;
    }
}
exports.CGJCycleElement = CGJCycleElement;
class CGJCycle {
    constructor(defaultSound, cycleElements) {
        this.defaultSound = defaultSound;
        this.elements = cycleElements;
        this.totalTime = 0;
        this.lastTime = 0;
        for (let i = 0; i < cycleElements.length; i++) {
            const element = cycleElements[i];
            this.totalTime += element.time;
            for (let j = 0; j < element.subCycles.length; j++) {
                element.subCycles[j].parent = element;
            }
        }
    }
    segmentForTime(time) {
        let remainingTime = time % this.totalTime;
        for (let i = 0; i < this.elements.length; i++) {
            if (remainingTime <= this.elements[i].time) {
                return [this.elements[i], remainingTime / this.elements[i].time];
            }
            remainingTime -= this.elements[i].time;
        }
        return [this.elements[this.elements.length - 1], this.elements[this.elements.length - 1].time];
    }
    indexForTime(time) {
        let remainingTime = time % this.totalTime;
        for (let i = 0; i < this.elements.length; i++) {
            if (remainingTime <= this.elements[i].time) {
                return [i, remainingTime];
            }
            remainingTime -= this.elements[i].time;
        }
    }
    /**
     *
     * @param from Start time
     * @param to End time
     * @returns Array of [element, delta, percent]
     */
    segmentsFrom(from, to) {
        if (from > to)
            throw "To time must not be less than from! " + from + " to " + to;
        if (this.totalTime == 0)
            return [];
        const indexInfo = this.indexForTime(from);
        let remainingTime = to - from + indexInfo[1];
        let idx = indexInfo[0];
        let ret = [];
        let first = true;
        while (remainingTime >= 0) {
            const element = this.elements[idx];
            if (remainingTime < element.time) {
                ret.push([element, remainingTime - (first ? indexInfo[1] : 0), remainingTime / element.time]);
                return ret;
            }
            ret.push([element, element.time, 1]);
            remainingTime -= element.time;
            idx = (idx + 1) % this.elements.length;
            first = false;
        }
    }
    /**
     *
     * @param now Current time
     * @param delta
     * @returns Percentage of time through rotation
     */
    update(now, delta) {
        if (this.parent && !this.parent.active) {
            this.startTime = undefined;
            this.lastTime = undefined;
            return;
        }
        if (this.startTime === undefined) {
            this.startTime = now - delta;
            this.lastTime = 0;
            this.elements[0].active = true;
            if (this.elements[0].startCallback)
                this.elements[0].startCallback();
            if (this.elements[0].progressCallback)
                this.elements[0].progressCallback(0, 0, 0);
            return this.update(now, delta);
        }
        else {
            const timeSinceStart = now - this.startTime;
            const segments = this.segmentsFrom(this.lastTime, timeSinceStart);
            for (let i = 0; i < segments.length; i++) {
                const segment = segments[i][0];
                if (!segment.active && segments[i][1] > 0) {
                    segment.active = true;
                    if (segment.startCallback)
                        segment.startCallback();
                    if (segment.sound)
                        segment.sound.play();
                    else if (this.defaultSound)
                        this.defaultSound.play();
                }
                if (segment.progressCallback)
                    segment.progressCallback(segments[i][2] * segment.time, segments[i][1], segments[i][2]);
                if (segments[i][2] >= 1) {
                    this.updateSubCycles(segment.time, segments[i][1], segment);
                    segment.active = false;
                    if (segment.endCallback)
                        segment.endCallback();
                }
                this.updateSubCycles(segments[i][2] * segment.time, segments[i][1], segment);
            }
        }
        this.lastTime = now - this.startTime;
        const percent = (now - this.startTime) / this.totalTime % 1;
        if (this.graphic)
            this.graphic.update(percent);
        return percent;
    }
    updateSubCycles(now, delta, cycleElement) {
        for (let i = 0; i < cycleElement.subCycles.length; i++) {
            cycleElement.subCycles[i].update(now, delta);
        }
    }
    reset() {
        this.startTime = 0;
    }
}
exports.CGJCycle = CGJCycle;
